import PropTypes from 'prop-types';

var getResponsivePropType = function getResponsivePropType(x) {
  return PropTypes.oneOfType([x, PropTypes.object, PropTypes.arrayOf(x)]);
};

export var responsiveNumber = getResponsivePropType(PropTypes.number);